import React from 'react';
import type { GetFeaturesInnerParams } from '@/app/components/search/components/EvolutionCard/Details/Features/getFeatures/types.ts';
import {
  type Feature,
  FeatureType,
  type TooltipRenderProps,
} from '@/app/components/search/components/EvolutionCard/utils/facilitiesTypes.ts';
import TsxTooltip from '@/app/components/search/components/Tooltip/TsxTooltip';
import type { StarfishIconRef } from '@/app/common/icons/starfish';

// Indexed by meal plan: any, room only, breakfast, half board, full board, all inclusive.
const MEAL_ICONS: StarfishIconRef[] = [
  { category: 'Food and beverages', name: 'icon-cutlery', color: 'iconPrimary' },
  { category: 'Food and beverages', name: 'icon-slashed-cutlery', color: 'iconPrimary' },
  { category: 'Food and beverages', name: 'icon-breakfast', color: 'iconPrimary' },
  { category: 'Food and beverages', name: 'icon-half-board', color: 'iconPrimary' },
  { category: 'Food and beverages', name: 'icon-full-board', color: 'iconPrimary' },
  { category: 'Food and beverages', name: 'icon-all-inclusive', color: 'iconPrimary' },
];

export const getMealFeatures = ({ meal, t, mealPlan, isMealFilterApplied }: GetFeaturesInnerParams): Feature[] =>
  meal
    ? [
        {
          text: meal,
          icon: mealPlan !== undefined ? MEAL_ICONS[mealPlan] : undefined,
          className: 'meal',
          featureType: FeatureType.dotted,
          Tooltip: (props: TooltipRenderProps) => (
            <TsxTooltip
              text={meal}
              tooltip={t(
                isMealFilterApplied ? 'vacation.oss.cards.meal_applied_tooltip' : 'vacation.oss.cards.meal_tooltip'
              )}
              size={232}
              {...props}
            />
          ),
        },
      ]
    : [];
